import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/landing/Navbar";
import Hero from "./components/landing/Hero";
import Marquee from "./components/landing/Marquee";
import ThemedRooms from "./components/landing/ThemedRooms";
import Amenities from "./components/landing/Amenities";
import Gallery from "./components/landing/Gallery";
import Availability from "./components/landing/Availability";
import Location from "./components/landing/Location";
import Reviews from "./components/landing/Reviews";
import InquiryForm from "./components/landing/InquiryForm";
import Footer from "./components/landing/Footer";
import { captureUtms, appendUtms, trackBookingClick } from "./lib/analytics";

export const BOOKING_URL = "https://hometeamvr.guestybookings.com/en/properties/6a186aa542dc3400127636ed";
export const AIRBNB_URL = "https://www.airbnb.com/rooms/1714671107106561677?guests=1&adults=1&s=67&unique_share_id=b6435ff4-4e39-4f5f-9b7c-5a533dfe7172";

const Landing = () => {
  useEffect(() => {
    captureUtms();
  }, []);

  const openBooking = (source) => {
    const finalUrl = appendUtms(BOOKING_URL);
    trackBookingClick({ destinationUrl: finalUrl, source: source || "unknown" });
    window.open(finalUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#FFFDF9] text-slate-900">
      <Navbar onBook={() => openBooking("navbar")} />
      <Hero onBook={() => openBooking("hero_primary")} />
      <Marquee />
      <ThemedRooms onBook={() => openBooking("room_whole_home")} />
      <Gallery />
      <Availability onBook={() => openBooking("availability_section")} />
      <Amenities />
      <Location />
      <Reviews />
      <InquiryForm />
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
